import { Typography, TypographyProps } from '@goshippo/components';

type Props = {
  title: string;
} & Omit<TypographyProps<'h1'>, 'component'>;

export const PageHeader = ({ title, ...rest }: Props) => (
  <Typography component="h1" fontWeight="bold" variant="h1" {...rest}>
    {title}
  </Typography>
);
